"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAnnualMotorTierUpgradeModals = void 0;
var React = require("react");
var TierUpgradeModal_1 = require("../../../widgets/annual/motor/TierUpgradeModal");
var getAnnualMotorTierUpgradeModals = function (state, toggleChange, closeModal, bindFromField) {
    var tierEligibility = bindFromField("tierEligibility");
    var tierAvailable = function (requiredTier) {
        return !!(tierEligibility === null || tierEligibility === void 0 ? void 0 : tierEligibility[requiredTier]);
    };
    var choice = function (first, separator, second) {
        var items = [
            tierAvailable("silver") && first,
            tierAvailable("allianz") && second
        ].filter(Boolean);
        return items.reduce(function (acc, item, index) {
            acc.push(item);
            if (index < items.length - 1) {
                acc.push(separator);
            }
            ;
            return acc;
        }, []);
    };
    var modals = [
        {
            stateKey: "showModalEssentialsGHCAndMLESelected",
            title: "Because of the changes you've made...",
            explanation: (React.createElement("p", null,
                "You may consider our ",
                React.createElement("strong", null, "Allianz"),
                " cover level, our highest level of comprehensive car insurance which includes Motor Legal Expenses and Guaranteed Hire Car as standard.")),
            query: "Do you want to upgrade your cover level from Allianz Essentials to Allianz?",
            tierUpgradeButtons: [
                {
                    buttonText: "Yes, upgrade to Allianz",
                    onClick: function () { return toggleChange("ALLIANZ", "showModalEssentialsGHCAndMLESelected"); },
                    key: "showModalEssentialsGHCAndMLESelectedALLIANZ",
                    hide: false
                },
            ],
        },
        {
            stateKey: "showModalEssentialsGHCSelected",
            title: "Because of the changes you've made...",
            explanation: (React.createElement(React.Fragment, null,
                React.createElement("p", null,
                    "You may like to consider  ",
                    choice(React.createElement("strong", null, "Allianz Silver"), ' or our ', React.createElement("strong", null, "Allianz")),
                    " cover level."),
                tierAvailable("silver") &&
                    React.createElement("p", null,
                        React.createElement("strong", null, "Allianz Silver"),
                        " includes a ",
                        React.createElement("strong", null, "guaranteed hire car"),
                        " if yours is being repaired."),
                tierAvailable("allianz") &&
                    React.createElement("p", null,
                        React.createElement("strong", null, "Allianz"),
                        " is our highest level of cover and includes ",
                        React.createElement("strong", null, "motor legal expenses"),
                        ", plus ",
                        React.createElement("strong", null, "guaranteed hire car"),
                        " during repairs and if your car's stolen or not repairable."))),
            query: React.createElement(React.Fragment, null,
                "Would you like to upgrade your Allianz Essentials cover level to ",
                choice('Allianz Silver', ' or ', 'Allianz'),
                "?"),
            tierUpgradeButtons: [
                {
                    buttonText: "Yes, upgrade to Allianz Silver",
                    onClick: function () { return toggleChange("ALLIANZ_SILVER", "showModalEssentialsGHCSelected"); },
                    key: "showModalEssentialsGHCSelectedALLIANZ_SILVER",
                    hide: !tierAvailable("silver"),
                },
                {
                    buttonText: "Yes, upgrade to Allianz",
                    onClick: function () { return toggleChange("ALLIANZ", "showModalEssentialsGHCSelected"); },
                    key: "showModalEssentialsGHCSelectedALLIANZ",
                    hide: !tierAvailable("allianz"),
                },
            ],
        },
        {
            stateKey: "showModalEssentialsMLESelected",
            title: "Because of the changes you've made...",
            explanation: (React.createElement(React.Fragment, null,
                React.createElement("p", null,
                    "You may like to consider ",
                    choice(React.createElement("strong", null, "Allianz Silver"), ' or our ', React.createElement("strong", null, "Allianz")),
                    " cover level."),
                tierAvailable("silver") &&
                    React.createElement("p", null,
                        React.createElement("strong", null, "Allianz Silver"),
                        " includes a ",
                        React.createElement("strong", null, "guaranteed hire car"),
                        " if yours is being repaired."),
                tierAvailable("allianz") &&
                    React.createElement("p", null,
                        React.createElement("strong", null, "Allianz"),
                        " is our highest level of cover and includes ",
                        React.createElement("strong", null, "motor legal expenses"),
                        ", plus ",
                        React.createElement("strong", null, "guaranteed hire car"),
                        " during repairs and if your car's stolen or not repairable."))),
            query: React.createElement(React.Fragment, null,
                "Would you like to upgrade your Allianz Essentials cover level to ",
                choice('Allianz Silver', ' or ', 'Allianz'),
                "?"),
            tierUpgradeButtons: [
                {
                    buttonText: "Yes, upgrade to Allianz Silver",
                    onClick: function () { return toggleChange("ALLIANZ_SILVER", "showModalEssentialsMLESelected"); },
                    key: "showModalEssentialsMLESelectedALLIANZ_SILVER",
                    hide: !tierAvailable("silver"),
                },
                {
                    buttonText: "Yes, upgrade to Allianz",
                    onClick: function () { return toggleChange("ALLIANZ", "showModalEssentialsMLESelected"); },
                    key: "showModalEssentialsMLESelectedALLIANZ",
                    hide: !tierAvailable("allianz"),
                },
            ],
        },
        {
            stateKey: "showModalSilverGHCAndMLESelected",
            title: "Because of the changes you've made...",
            explanation: (React.createElement(React.Fragment, null,
                React.createElement("p", null,
                    "You may like to consider our ",
                    React.createElement("strong", null, "Allianz"),
                    " cover level."),
                React.createElement("p", null,
                    React.createElement("strong", null, "Allianz"),
                    " is our highest level of cover and includes ",
                    React.createElement("strong", null, "motor legal expenses"),
                    ", plus ",
                    React.createElement("strong", null, "guaranteed hire car"),
                    " during repairs and if your car's stolen or not repairable."))),
            query: "Would you like to upgrade your Allianz Silver cover level to Allianz?",
            tierUpgradeButtons: [
                {
                    buttonText: "Yes, upgrade to Allianz",
                    onClick: function () { return toggleChange("ALLIANZ", "showModalSilverGHCAndMLESelected"); },
                    key: "showModalSilverGHCAndMLESelectedALLIANZ",
                    hide: false,
                },
            ],
        },
        {
            stateKey: "showModalSilverMLESelected",
            title: "Because of the changes you've made...",
            explanation: (React.createElement(React.Fragment, null,
                React.createElement("p", null,
                    "You may like to consider our ",
                    React.createElement("strong", null, "Allianz"),
                    " cover level."),
                React.createElement("p", null,
                    React.createElement("strong", null, "Allianz"),
                    " is our highest level of cover and includes ",
                    React.createElement("strong", null, "motor legal expenses"),
                    ", plus ",
                    React.createElement("strong", null, "guaranteed hire car"),
                    " during repairs and if your car's stolen or not repairable."))),
            query: "Would you like to upgrade your Allianz Silver cover level to Allianz?",
            tierUpgradeButtons: [
                {
                    buttonText: "Yes, upgrade to Allianz",
                    onClick: function () { return toggleChange("ALLIANZ", "showModalSilverMLESelected"); },
                    key: "showModalSilverMLESelectedALLIANZ",
                    hide: false,
                },
            ],
        },
    ];
    return modals
        .filter(function (modal) { return state[modal.stateKey]; })
        .map(function (modal) { return (React.createElement(TierUpgradeModal_1.TierUpgradeModal, { key: modal.stateKey, showModal: state[modal.stateKey], onClose: function () { return closeModal(modal.stateKey); }, title: modal.title, explanation: modal.explanation, query: modal.query, tierUpgradeButtons: modal.tierUpgradeButtons })); });
};
exports.getAnnualMotorTierUpgradeModals = getAnnualMotorTierUpgradeModals;
//# sourceMappingURL=AnnualMotorTierUpgradeModals.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/helpers/annual/motor/AnnualMotorTierUpgradeModals.js
// module id = 1248
// module chunks = 0